<template>
  <div class="contents">
    <goods-class-title
      :imgwidth="527"
      :src="require('@/assets/images/goodsclass.png')"
    ></goods-class-title>

    <div class="brandlist">
      <ul>
        <li
          v-for="(classinfo, index) in classinfos"
          :key="index"
          :class="{
            rightone: (index + 1) % 7 == 0 || index + 1 == classinfos.length,
            leftone: (index + 1) % 8 == 0
          }"
        >
          <goods-class-item
            :classinfo="classinfo"
            :type="index < classinfos.length - 1"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import GoodsClassItem from "./GoodsClassItem.vue";
import GoodsClassTitle from "./GoodsClassTitle.vue";
export default {
  data() {
    return {
      classinfos: {}
    };
  },
  components: { GoodsClassTitle, GoodsClassItem },
  methods: {
    articleitemData() {
      this.$api.index.getIndexClass(0).then(res => {
        var info = {};
        info.icon = "/static/index/goodsnoselected.png";
        info.iconed = "/static/index/goodsselected.png";
        info.id = 0;
        info.name = "全部商品";
        this.classinfos = res.data.datas;
        this.classinfos.push(info);
      });
    }
  },
  mounted() {
    this.articleitemData();
  }
};
</script>

<style scoped>
.brandlist {
  margin-bottom: 145px !important;
}
.brandlist ul {
  /* display: flex;
        justify-content: space-between; */
  width: 1198px;
  margin: 0 auto;
  overflow: hidden;
  text-align: center;
}
.brandlist ul li {
  width: 154px;
  float: left;
  margin-right: 20px;
  margin-bottom: 30px;
}
.brandlist .rightone {
  margin-right: 0;
}
.brandlist .leftone {
  margin-left: 260px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/GoodsClass.vue